// | ------------------------------------------------------------------------
// | Hero Parallax Blur
// | ------------------------------------------------------------------------ 


function parallaxBlur() {

    var parallaxElement = document.querySelector('.parallax-bg');
  
    if(parallaxElement){
  
      var elementHeight = parallaxElement.offsetHeight;
  
      var scrollPos = window.pageYOffset;
      var transformValue = scrollPos/40;
      var opacityValue =  1 - ( scrollPos / 1000);
      var blurValue = Math.min(scrollPos / 100, 3);
      
      if ( scrollPos < elementHeight ) {
        Object.assign(parallaxElement.style, {transform: "translate3d(0," + transformValue + "%, 0)", opacity: "" + opacityValue + "", filter: "blur(" + blurValue + "px)"})
      }
  
    }
    
}
  
window.addEventListener("scroll", parallaxBlur, false);
